<template lang="pug">
.box-lesson
  .container
    .box-lesson-top  
        span.beehive 
            img(src="../../../../assets/images/home/ic_lythuyet.png")          
        .title {{$t("home.lesson.title")}}
        router-link.view-more(:to="{ name: 'page_lesson'}") {{$t("home.view_more")}} >>
    .box-lesson-search
        .input-group
            input(:placeholder="$t('home.lesson.keyword')" v-model="key_lesson" @keyup="onLessonChange")
            .addons-button-clear(@click="onLessonClear" v-bind:style="clear_lesson ? 'display:block;' : 'display:none;' ")
            .addons-button(@click="onLessonSearch")
                span.material-icons search
    .box-lesson-content
        .row(v-if="lstLessons.length")
          div(v-for="(lesson, index) in lstLessons")
            FrontItem(:lesson="lesson" :obj_id="lesson.id")
          .clearfix
          router-link.view-more.mobile(:to="{ name: 'page_lesson', query: {front_top: 0}}") {{$t("home.view_more")}} >>
        .row(v-else)
           .no-data.col-md-12.col-sm-12.col-xs-12 {{no_data}}
  .clearfix
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../../../Model/graphqlfront'
import FrontItem from './Item.vue'
export default {
  components: {
    FrontItem
  },
  data() {
    return {
      lstLessons: [],
      key_lesson: '',
      clear_lesson: 0,
      lstLikes: [],
      no_data: this.$t('home.no_data')
    }
  },
  methods: {
    onLessonAll() {
      this.$router.push({name: 'page_lesson'})
    },
    onLessonSearch() {
      if (this.key_lesson.length > 0) {
        this.$router.push({name: 'page_lesson', query: {front_top: 0, keyword: this.key_lesson}})
        // this.onRefresh()
      }
    },
    onLessonChange(events) {
      if (events.key === 'Enter') {
        this.onLessonSearch()
      } else {
        if (this.key_lesson.trim().length) this.clear_lesson = 1
        else this.onLessonClear()
      }
    },
    onLessonClear() {
      this.key_lesson = ''
      this.clear_lesson = 0
      this.onRefresh()
    },
    onRefresh() {
      this.lstLessons = []
      var variables = {
        limit: 6,
        is_public: 2,
        type_lesson: 1
      }
      if (this.key_lesson.length > 0) {
        variables = Object.assign(variables, {keyword: '%' + this.key_lesson + '%'})
      }
      this.$apollo.query({
        query: gql(graphql.GET_LESSONS_HOME),
        variables: variables
      }).then((response) => {
        this.lstLessons = response.data.v_front_lesson
      })
    }
  },
  created () {
    this.onRefresh()
  },
  apollo: {
  }
}
</script>
<style lang="scss">
.content.front{
    .box-lesson{margin-top:0; margin-bottom: 0px;
        .box-lesson-top{
          .title{text-align: left;font-weight: bold; font-size: 25px;letter-spacing: 0px;color: #23180A;text-transform: uppercase; display: inline-block; }
          .view-more{cursor: pointer; float:right; color: #1A0DAB; font-size:15px;margin-top:5px;}
          .view-more.mobile{display: none;}
        }
        .box-lesson-search{margin: 10px 0 20px;position: relative;
            input{display:block; border: 1px solid #9F6A28; border-radius: 10px; padding: 12px 75px 12px 15px; width: 500px;background: #FBF4D2;}
            input::placeholder{color: #B4B4B4;}
            input::-moz-placeholder{color: #B4B4B4;}
            input::-webkit-input-placeholder {color: #B4B4B4;}
            input::-ms-input-placeholder {color: #B4B4B4;}
            .addons-button{cursor: pointer; background: #FFEF45; display: inline-block; position: absolute; right:1px; top:1px;width: 40px;  height: 44px;border-radius: 10px; border-top-left-radius: 0;border-bottom-left-radius: 0;
                span{transform: translate(9px, 12px); color: #9F6A28;}
            }
            .addons-button-clear{cursor: pointer;display: none; background: url("../../../../assets/images/faces/ic_clear_24px.png") no-repeat center center; position: absolute; right:40px; top:1px;width: 40px;  height: 44px;border-radius: 10px; border-top-left-radius: 0;border-bottom-left-radius: 0;}
        }
        .box-lesson-content{
            .box-parent-lesson{margin-bottom:30px;
                .box-info{margin-bottom: 10px;
                    .avatar{vertical-align: inherit;width: 40px; height: 40px; display: flex;float: left; border-radius: 50%; overflow: hidden;
                        img{max-width:100%; height: auto; margin: auto;}
                    }
                    .item-info{display: inline-block;margin-left:10px;
                        span.fullname{cursor: pointer;display:block;color:#4B2D15; font-size:14px;font-weight: 400;}
                        span.subjects{cursor: pointer; display: inline-block;color:#3A9F00;font-size:14px; padding-right:20px;font-weight: 400;}
                        span.grades{cursor: pointer; display: inline-block;color:#9F6A28;font-size:14px;font-weight: 400;}
                    }
                }
                .box-item-lesson{cursor: pointer;border-radius: 5px; position: relative; height: 130px; overflow: hidden; display:flex;justify-content: center;align-items:center;box-shadow: 0px 3px 6px #00000029;
                  .overlay{width: 100%; position: absolute;height:100%; background: transparent linear-gradient(180deg, #FAFAFA00 0%, #EFDAC934 0%, #9F6A28 100%) 0% 0% no-repeat padding-box;}
                  a{display: block; width: 100%; height: 100%;
                    img{max-width: 100%; height: 100%; display: block; margin: 0 auto;object-fit: contain;}
                  }
                  .item-title{ position: absolute; bottom:10px;padding: 0 10px;width: 100%;
                    span{color: #fff; font-weight: 400;}
                  }
                }
                .item-social{margin-top:10px; display: table; width:100%;
                    span { display: table-cell;  width: 33.33%;font-size:13px;
                      i{color:#4B2D15; font-size:13px;
                          &:before{padding-right: 5px;}
                          img{width: 16px; height: 16px; margin-right: 5px; position: relative; top:-2px;}
                      }
                      i.like{cursor: pointer;}
                    }
                }
            }
            .view-more.mobile{display: none; color: #1A0DAB;}
            .no-data{text-align: center; margin: 15px 0;color: #9F6A28; font-size:15px;}
        }
    }
}
@media (max-width: 1366px){
    .content.front{
        .box-lesson{
            .box-lesson-content{
                .view-more.mobile{ display: none;}
            }
        }
    }
}
@media (max-width: 1024px){
    .content.front{
        .box-lesson{
            .box-lesson-content{
                .view-more.mobile{ display: none; }
            }
        }
    }
}
@media (max-width: 991px){
    .content.front{
        .box-lesson{
            .box-lesson-content{
                .box-parent-lesson{width: 50%;}
            }
        }
    }
}
@media (max-width: 768px){
    .content.front{
        .box-lesson{
            .box-lesson-top{
              .title{font-size:20px;}
            }
            .box-lesson-search{
                .input-group{width: 100%;
                    input{width: 100%;}
                }
            } 
        }
    }
}
@media (max-width: 560px){
    .content.front{
        .box-lesson{
            .box-lesson-top{
                .title{font-size:18px;}
                .view-more{display: none;}
            }
            .box-lesson-content{
                .view-more.mobile{ display: block; text-align: center; margin-bottom:20px;}
                .box-parent-lesson{width: 100% !important;
                    .box-item-lesson{height: 150px;}
                }
            }
            .box-lesson-search{
                .input-group{width: 100%;
                    input{width: 100%;}
                }
            } 
        }
    }
}
@media (max-width: 375px){
    .content.front{
        .box-lesson{
            .box-lesson-top{
                .title{font-size:18px;}
                .view-more{display: none;}
            }
            .box-lesson-content{
                .view-more.mobile{ display: block; text-align: center; margin-bottom:20px;}
                .box-parent-lesson{width: 100%;
                    .box-item-lesson{height: 150px;}
                }
            }
            .box-lesson-search{
                .input-group{width: 100%;
                    input{width: 100%;}
                }
            } 
        }
    }
}
</style>




// WEBPACK FOOTER //
// index.vue?0aab2d96